module.exports = __webpack_public_path__ + "static/media/soccer.3f05c346.svg";